<template>
  <div class="s-history">
    <SlickCarousel
      ref="slick"
      :key="'key-' + slickKey"
      class="s-history__slick"
      :options="slickOptions">
      <div
        v-for="(item, index) in records"
        :key="index"
        class="s-history__year item">
        <div v-if="item.data.length === 1" class="b-history">
          <div v-if="item.data[0].image" class="b-history__img">
            <img :src="item.data[0].image.url" :alt="item.data[0].image.alt" />
          </div>
          <div class="b-history__txt">
            <div class="title">{{ item.data[0].title }}</div>
            <div class="subtitle">
              {{ item.data[0].text }}
            </div>
          </div>
        </div>

        <SlickCarousel
          v-if="item.data.length > 1"
          ref="slick3"
          :key="'key3-' + slickKey"
          class="s-history__slick--inside"
          :options="slickInsideOptions">
          <div
            v-for="(itemEvent, dataIndex) in item.data"
            :key="dataIndex"
            class="b-history b-history--inside item">
            <div v-if="itemEvent.image" class="b-history__img">
              <img :src="itemEvent.image.url" :alt="itemEvent.image.alt" />
            </div>
            <div class="b-history__txt">
              <div class="title">{{ itemEvent.title }}</div>
              <div class="subtitle">
                {{ itemEvent.text }}
              </div>
            </div>
          </div>
        </SlickCarousel>
      </div>
    </SlickCarousel>
    <SlickCarousel
      ref="slick2"
      :key="'key2-' + slickKey"
      class="s-history__slick s-history__slick--nav"
      :options="slickNavOptions">
      <div v-for="(item, index) in records" :key="index" class="item">
        {{ item.year }}
      </div>
    </SlickCarousel>
  </div>
</template>
<script>
import * as lib from './../../lib/lib'
import SlickCarousel from './../components/common/SlickCarousel.vue'

export default {
  components: {
    SlickCarousel,
  },
  data() {
    return {
      // default
      isLoading: false,
      errorMsgs: [],

      records: [],

      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: false,
        dots: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        swipe: false,
        asNavFor: '.s-history__slick--nav',
      },
      slickInsideOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
      slickNavOptions: {
        infinite: false,
        autoplay: false,
        arrows: false,
        dots: false,
        slidesToShow: 6.3,
        slidesToScroll: 1,
        asNavFor: '.s-history__slick',
        centerMode: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 4.3 },
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 2.3 },
          },
        ],
      },
    }
  },
  mounted() {
    const { records } = lib.getData('historyData')
    this.records = records
  },
}
</script>
